var $04566bd4f80d56ce$exports = {};
// Tracked links: delegate listener per partner e internal link click.
// Pusha nel dataLayer con formato {event: 'nome'} per essere intercettato da GTM.
// Aggiungi data-track="partner" data-track-partner="Nome" ai link partner.
// Aggiungi data-track="internal:feature-name" ai CTA interni.
if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    document.addEventListener('click', (e)=>{
        const link = e.target.closest('a[data-track]');
        if (!link) return;
        const track = link.dataset.track;
        const page = window.location.pathname;
        const linkUrl = link.getAttribute('href') || '';
        if (track === 'partner') {
            const partner = link.dataset.trackPartner || 'unknown';
            window.dataLayer.push({
                event: 'partner_click',
                partner: partner,
                link_url: linkUrl,
                page_path: page
            });
        } else if (track.startsWith('internal:')) {
            const feature = track.slice(9);
            window.dataLayer.push({
                event: 'internal_nav',
                feature: feature,
                link_text: (link.textContent || '').trim().slice(0, 100),
                page_path: page
            });
        }
    // capture: i tooltip (js/tooltips.js) fermano la propagazione dei click al loro interno,
    // in fase di cattura il listener viene eseguito prima e il tracking non si perde.
    }, {
        capture: true,
        passive: true
    });
}


//# sourceMappingURL=s.ccff1c56.js.map
